
























import { DocumentNode, gql } from 'apollo-boost';
import { Component, Vue } from 'vue-property-decorator';

import Recipe from './components/recipes/Recipe.vue';

const gqlRecipes: DocumentNode = gql`query {
  recipes {
    id
    name
    current {
      ingredients
      instructions
      version
    }
    previous {
      ingredients
      instructions
      version
    }
  }
}`;

Component.registerHooks([
  'apollo',
]);

@Component({
  components: {
    Recipe,
  },
})
export default class App extends Vue {
  // TODO - create Recipe interface
  recipes: Array<any> = [];

  get apollo() {
    return {
      recipes: gqlRecipes,
    };
  }
}
